module.exports = __webpack_public_path__ + "static/UNITY-SQUARE-Two-4-tenants_v2-en-d9bb5e403753adb0d9b834c0a42e6ffc.pdf";